import styled from 'styled-components';
import { LinkWithNativeEvents } from '../../../../components/_common/link/link';

export const A = styled(LinkWithNativeEvents)<{
  onClick?: any;
  bold?: boolean;
}>`
  color: var(--cvna-color-blue-2) !important;
  cursor: pointer;
`;

export const Button = styled(LinkWithNativeEvents)`
  background: var(--cvna-color-blue-2);
  color: var(--cvna-color-white);
  padding: 13px 30px;
  text-align: center;
  line-height: 14px;
  text-decoration: none;
  border-radius: 7px;
  display: block;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    width: auto;
  }

  :hover {
    background: var(--cvna-color-blue-3);
    color: var(--cvna-color-white);
  }
`;
